<template>
  <v-card color="#F5F5F5" class="back pa-2 report-card">
    <v-card-title>1.2 - {{ $t('Solicitações por Instituição') }}</v-card-title>
    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="!showChart">
      {{ $t('Nenhuma solicitação encontrada') }}
    </v-alert>
    <v-card-text v-else>
      <strong>Total: {{ total }}</strong>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <PieChart
            :chartData="requestByDepartmentChartData"
            :options="options"
          />
        </v-col>
      </v-row>

      <!-- <PieChart :chart-data="requestByDepartmentChartData" :options="options" /> -->
      <!-- <strong>Total: {{ total }}</strong>
      <GChart
        type="PieChart"
        :data="googleChartData"
        :options="opt"
        v-if="haveResponse"
      />
      <TNoContent v-else /> -->

      <div class="wrapper">
        <v-data-table
          :loading="loading"
          :headers="requestByDepartmentHeader"
          :items="requestByDepartment"
          class="main-table"
          hide-default-footer
          hide-default-header
          :header-props="headerProps"
          :items-per-page="pageSize"
          :mobile-breakpoint="0"
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.department`]="{ item }">
            {{ item.departmentName }}
          </template>

          <template #[`item.quantity`]="{ item }">
            {{ item.serviceOrdersQuantity }}
          </template>
        </v-data-table>

        <div class="pagination">
          <div class="item-pagination block-two">
            <v-pagination
              class="pagination-item"
              v-model="page"
              :length="totalPages"
              :total-visible="3"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>
@import '@/sass/variables.scss';
.wrapper {
  padding: 0.5rem;

  .v-data-table {
    &::v-deep .v-data-table__wrapper {
      table {
        td {
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
  .table-custom {
    &::v-deep .v-data-table__wrapper {
      thead {
        border: none !important;

        th {
          border: none !important;
          &:first-child {
            border-radius: 4px 0 0 4px;
          }

          &:last-child {
            border-radius: 0 4px 4px 0;
          }
        }
      }
    }
  }

  .pagination {
    margin: 1.5rem 0;
    background: $grey-1;
    border-radius: 4px;
    padding: 0.3rem 1.3rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .item-pagination {
      flex: 1 1 100px;
      margin: 0.5rem 0;
      .btn {
        border-radius: 4px;
        background: #c7c9ca;
        font-weight: bold;
      }
      .registros {
        span {
          font-weight: 700;
          font-size: 12px;
          line-height: 16px;
          color: $grey-2;
        }
      }
    }
    .block-one {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .block-two {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .pagination-item {
        &::v-deep .v-pagination {
          li {
            button {
              box-shadow: none !important;
              background: none !important;
              color: $grey-2;
              font-weight: 500;
            }

            .v-pagination__item--active {
              color: $black-1;
            }
          }
        }
      }
    }

    @media (max-width: 406px) {
      .block-one {
        justify-content: center;
      }
      .block-two {
        justify-content: center;
      }
    }
  }
}

.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
</style>

<script>
import ApiService from '../../../../../../services/ApiService'
import PieChart from '../../../../Reports/components/charts/pieChart'

export default {
  props: {
    filter: Object,
  },

  async created() {
    this.listRequestByDepartment()
  },

  data: () => ({
    loading: false,
    showChart: true,
    page: 1,
    googleChartData: [],
    opt: {
      is3D: true,
    },
    totalPages: 1,
    pageSize: 7,
    haveResponse: false,
    departmentNames: [],
    requestQuantity: [],
    backgroundColors: [
      '#426483',
      '#BBCF20',
      '#0F3565',
      '#212950',
      '#C4E8F2',
      '#ED8990',
      '#FDB578',
      '#7EE882',
    ],
    requestByDepartment: [],
    requestByDepartmentChartData: {},
    options: {},
    requestByDepartmentHeader: [
      {
        text: 'Setor',
        align: 'left',
        value: 'department',
      },
      {
        text: 'Quantidade',
        align: 'center',
        value: 'quantity',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    total: 0,
  }),

  components: {
    PieChart,
  },

  methods: {
    fillRequestDepartment() {
      this.requestByDepartmentChartData = {
        labels: this.departmentNames,
        datasets: [
          {
            label: this.$t('Solicitações'),
            backgroundColor: this.backgroundColors,
            data: this.requestQuantity,
          },
        ],
      }
    },

    fillOptions() {
      this.options = {
        legend: {
          display: true,
          responsive: false,
          maintainAspectRatio: true,
          labels: {
            usePointStyle: true,
          },
        },
      }
    },

    async listRequestByDepartment() {
      await this.apiService
        .post('bigData/requestByDepartment', this.filter)
        .then((response) => {
          this.total = response.content.total
          this.requestByDepartment = response.content.objects
          this.totalPages = response.content.pager.totalPages

          this.departmentNames = []
          this.requestQuantity = []
          this.googleChartData = []

          this.showChart = response.content.objects.length > 0
          this.getBackgroundColors(response.content.chartsModel.length)

          this.haveResponse = response.content.chartsModel.length

          if (this.haveResponse) {
            response.content.chartsModel.map((chart) => {
              this.departmentNames.push(chart.name)
              this.requestQuantity.push(chart.quantity)

              this.googleChartData.push([chart.name, chart.quantity])
            })

            this.googleChartData.unshift([
              this.$t('Nome do departamento'),
              this.$t('Quantidade solicitações'),
            ])
          }
        })
        .catch((err) => {})

      this.fillRequestDepartment()
      this.fillOptions()
    },

    getBackgroundColors(length) {
      this.backgroundColors = [
        '#426483',
        '#BBCF20',
        '#0F3565',
        '#212950',
        '#C4E8F2',
        '#ED8990',
        '#FDB578',
        '#7EE882',
      ]

      for (let i = 0; i < length; i++) {
        this.backgroundColors.push(
          `#${Math.floor(Math.random() * 16777215).toString(16)}`
        )
      }
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.listRequestByDepartment()
    },
  },
}
</script>
